/**
 * Industry chips to render: every saved industry that is not on the fixed
 * list first, then the fixed list (QA D4-1).
 *
 * The URL analysis and the AI write free-text industries ("Marketing
 * Agencies", "B2B SaaS") that are not in INDUSTRIES. Rendering only the fixed
 * list hid them: they were saved and used for lead search, but the user could
 * neither see nor remove them. Passing the server copy as well as the form
 * keeps a chip on screen after it is switched off, so it can be switched
 * back on before saving.
 */
export function industryChips(
  fixed: readonly string[],
  ...saved: ReadonlyArray<readonly string[] | undefined>
): readonly string[] {
  const extras: string[] = []
  for (const list of saved) {
    for (const industry of list ?? []) {
      if (!fixed.includes(industry) && !extras.includes(industry)) extras.push(industry)
    }
  }
  return [...extras, ...fixed]
}
